import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { autoLogout } from '../../../redux/slices/authSlice';
import { t } from '../../../helpers/translation_helper';
import sessionService from '../../../services/session';

class SessionWarning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      remainingTime: 0,
    };
  }

  componentDidMount() {
    this.warningInterval = setInterval(() => {
      const remainingTime = sessionService.getRemainingTime();
      const warningTime = 15 * 60 * 1000;

      if (remainingTime > 0 && remainingTime <= warningTime && !this.state.showWarning) {
        this.setState({
          showWarning: true,
          remainingTime: remainingTime,
        });
      } else if (remainingTime <= 0) {
        this.handleLogout();
      }
    }, 60000);
  }

  componentWillUnmount() {
    if (this.warningInterval) {
      clearInterval(this.warningInterval);
    }
  }

  handleLogout = () => {
    this.props.autoLogout();
  };

  handleContinue = () => {
    this.setState({ showWarning: false });
  };

  formatTime = (milliseconds) => {
    const minutes = Math.floor(milliseconds / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours}h ${remainingMinutes}m`;
    }
    return `${remainingMinutes}m`;
  };

  render() {
    const { showWarning, remainingTime } = this.state;

    return (
      <Modal show={showWarning} backdrop="static" keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>{t('Session Expiry Warning')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('Your session will expire in')} <strong>{this.formatTime(remainingTime)}</strong>.</p>
          <p>{t('You will be automatically logged out for security reasons.')}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleLogout}>
            {t('Logout Now')}
          </Button>
          <Button variant="primary" onClick={this.handleContinue}>
            {t('Continue Session')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = () => ({
  autoLogout,
});

export default connect(null, mapDispatchToProps())(SessionWarning);